/**
 * InviteCodeModal — Create a new agent invitation code.
 * Extracted from ManagePlatform.js.
 */
import { Ticket, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

export default function InviteCodeModal({
  open, onOpenChange,
  newCodeMaxUses, setNewCodeMaxUses,
  newCodeExpiresDays, setNewCodeExpiresDays,
  onCancel, onSubmit, creatingCode,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a2e] border-[#2a2a4e] text-white max-w-md" data-testid="invite-code-modal">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2">
            <Ticket className="h-6 w-6 text-amber-500" />
            إنشاء كود دعوة جديد
          </DialogTitle>
          <DialogDescription className="text-[#808080]">حدد خيارات كود الدعوة الجديد</DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div>
            <label className="text-sm text-[#808080] mb-2 block">عدد الاستخدامات المسموح</label>
            <Input
              type="number" min="1" max="100"
              value={newCodeMaxUses}
              onChange={(e) => setNewCodeMaxUses(parseInt(e.target.value) || 1)}
              className="bg-[#0a0a0a] border-[#2a2a4e] text-white"
              data-testid="invite-code-max-uses"
            />
          </div>
          <div>
            <label className="text-sm text-[#808080] mb-2 block">صلاحية الكود (أيام)</label>
            <Input
              type="number" min="1" max="365"
              value={newCodeExpiresDays}
              onChange={(e) => setNewCodeExpiresDays(parseInt(e.target.value) || 30)}
              className="bg-[#0a0a0a] border-[#2a2a4e] text-white"
              data-testid="invite-code-expires-days"
            />
          </div>
          <div className="p-3 bg-amber-500/10 border border-amber-500/30 rounded-xl">
            <p className="text-xs text-amber-400 text-center">سيتم إنشاء كود بصيغة INV-XXXXXX</p>
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button onClick={onCancel} variant="outline" className="border-[#2a2a4e] text-white hover:bg-[#2a2a4e]">
            إلغاء
          </Button>
          <Button
            onClick={onSubmit}
            disabled={creatingCode}
            className="bg-amber-500 hover:bg-amber-600 text-black"
            data-testid="invite-code-submit-btn"
          >
            {creatingCode ? <Loader2 className="h-4 w-4 animate-spin" /> : 'إنشاء الكود'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
